module.exports = __webpack_public_path__ + "img/fi.2c4214ae.svg";